export default __webpack_public_path__ + "static/media/report_sample_image.62d4d767.svg";